var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M25.5,10.2c-1-0.8-2-1.7-2.9-2.7c0,0-3.6,4.6-12.7,8c0,2.3,0.3,4.7,1,6.9c1.6,5.2,4.8,9.8,9,13.2 c0.9,0.7,1.8,1.3,2.7,1.9c5.5-3.5,9.6-8.8,11.6-15c0.8-2.3,1.1-4.6,1-7C31.7,14.2,28.4,12.5,25.5,10.2z M11.8,16.8 c4-1.5,7.6-3.8,10.8-6.6v12.2h-9.7C12.2,20.6,11.8,18.7,11.8,16.8z M22.5,35.2V22.5h9.7C30.4,27.7,27,32.1,22.5,35.2z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M22.5,22.5v12.7c4.5-3.1,7.9-7.5,9.7-12.7H22.5z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M22.5,22.4V10.2c-3.2,2.8-6.8,5.1-10.8,6.6c0.1,1.9,0.5,3.8,1.1,5.6H22.5z"
});

function SvgSecurity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.fb9ac5c94000661da4eed7498d81adc7.svg";
export { ForwardRef as ReactComponent };